__turbopack_context__.v({
  "TableScroll": "TableScroll-module-scss-module__hJLSRa__TableScroll",
  "TableScroll___fullWidth": "TableScroll-module-scss-module__hJLSRa__TableScroll___fullWidth",
  "TableScroll___inverseScroll": "TableScroll-module-scss-module__hJLSRa__TableScroll___inverseScroll",
  "TableScroll___inverseYScroll": "TableScroll-module-scss-module__hJLSRa__TableScroll___inverseYScroll",
  "TableScroll___windowsNavigator": "TableScroll-module-scss-module__hJLSRa__TableScroll___windowsNavigator",
});
